import { YA_SCRIPT_ID, YA_SCRIPT_BASE_SRC } from './mapConstants';
import type { YMaps } from './types';

let ymapsPromise: Promise<YMaps> | null = null;

export const loadYmaps = (apiKey: string): Promise<YMaps> => {
  if (ymapsPromise) return ymapsPromise;

  ymapsPromise = new Promise<YMaps>((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('Яндекс.Карты доступны только на клиенте'));
      return;
    }

    const onReady = (): void =>
      window.ymaps?.ready(() => {
        if (window.ymaps) resolve(window.ymaps);
      });

    if (window.ymaps) {
      onReady();
      return;
    }

    const existing = document.getElementById(YA_SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', onReady);
      existing.addEventListener('error', () =>
        reject(new Error('Не удалось загрузить Яндекс.Карты')),
      );
      return;
    }

    const script = document.createElement('script');
    script.src = `${YA_SCRIPT_BASE_SRC}&apikey=${apiKey}`;
    script.async = true;
    script.id = YA_SCRIPT_ID;
    script.onload = onReady;
    script.onerror = (): void => {
      ymapsPromise = null;
      reject(new Error('Не удалось загрузить Яндекс.Карты'));
    };
    document.head.appendChild(script);
  });

  return ymapsPromise;
};
